import moment from 'moment-timezone'
import DatePicker, { registerLocale } from 'react-datepicker'
import de from 'date-fns/locale/de'
import getTranslationStringById from '../../Translation/func/getTranslationStringById'

registerLocale('de', de)

const toDisplayDate = (value, timezone) => {
    if (!value) return null
    const m = moment.tz(value, timezone)
    return new Date(m.year(), m.month(), m.date(), m.hours(), m.minutes())
}

const combine = (datePart, timePart, timezone) => {
    if (!datePart) return null
    return moment.tz({
        year: datePart.getFullYear(),
        month: datePart.getMonth(),
        day: datePart.getDate(),
        hour: timePart ? timePart.getHours() : 0,
        minute: timePart ? timePart.getMinutes() : 0,
    }, timezone).valueOf()
}

const DateTimePickerContainer = ({ name, value, onChange, timezone, id, className, translationStrings, currentLang, disabled = false }) => {
    const now = new Date()
    const displayValue = toDisplayDate(value, timezone)
    const datePlaceholder = getTranslationStringById('formik_datepicker_choose_date', translationStrings, currentLang, 'Datum wählen')
    const timePlaceholder = getTranslationStringById('formik_datepicker_choose_time', translationStrings, currentLang, 'Uhrzeit wählen')
    const isToday = displayValue
        && displayValue.getFullYear() === now.getFullYear()
        && displayValue.getMonth() === now.getMonth()
        && displayValue.getDate() === now.getDate()

    return (
        <div className="datetime-picker">
            <DatePicker
                id={id}
                className={className}
                selected={displayValue}
                onChange={date => onChange(name, combine(date, displayValue, timezone))}
                dateFormat="dd/MM/yyyy"
                locale="de"
                placeholderText={datePlaceholder}
                disabled={disabled}
                minDate={now}
                isClearable
            />
            <DatePicker
                className={className}
                selected={displayValue}
                onChange={time => onChange(name, combine(displayValue, time, timezone))}
                dateFormat="HH:mm"
                locale="de"
                placeholderText={timePlaceholder}
                disabled={disabled}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                timeCaption="Uhrzeit"
                {...(isToday ? { minTime: now, maxTime: new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59) } : {})}
            />
        </div>
    )
}

export default DateTimePickerContainer
